<template>

    <div>
        <v-card flat v-if="filtersExist">
            <v-card-text class="pa-0">

                <v-list dark dense class="grey darken-2">

                    <v-subheader>
                        Filters
                    </v-subheader>

                    <v-divider></v-divider>

                    <!-- ACTIVITY FILTER -->
                    <v-list-item v-if="filter.active">
                        <v-list-item-avatar>
                            <v-icon>mdi-check</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content class="body-2">
                            <v-list-item-title>
                                <v-tooltip color="primary" top>
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on">
                                            {{filtersText}}
                                        </div>
                                    </template>
                                    {{filtersText}}
                                </v-tooltip>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- EXCLUDE CATEGORIES -->
                    <v-divider v-if="filter.excludeCategoriesActive"></v-divider>

                    <v-list-item v-if="filter.excludeCategoriesActive">
                        <v-list-item-avatar>
                            <v-icon>mdi-check</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title class="body-2">
                                <v-list-item-title>
                                    {{excludeCategoriesStatusesText}} and participated in the following categories in
                                    the past {{excludeCategoriesDaysText}} days
                                </v-list-item-title>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="filter.excludeCategoriesActive">
                        <v-list-item-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-subtitle>
                                <categories-visualizer
                                        :selected="filter.excludeCategories"
                                ></categories-visualizer>
                            </v-list-item-subtitle>

                        </v-list-item-content>
                    </v-list-item>

                    <!-- SUB PANELS -->
                    <v-divider v-if="filter.includeSubpanelsActive"></v-divider>

                    <v-list-item v-if="filter.includeSubpanelsActive">
                        <v-list-item-avatar>
                            <v-icon>mdi-check</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content class="body-2">
                            <v-list-item-title>
                                Search in the following sub-panels only
                            </v-list-item-title>

                            <sub-panel-chips
                                    :selected="filter.includeSubpanels"
                            ></sub-panel-chips>

                        </v-list-item-content>
                    </v-list-item>

                </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

    import CategoriesVisualizer from "../../ProjectManager/components/CategoryChips";
    import SubPanelChips from "../../ProjectManager/components/SubpanelChips";

    export default {
        components: {
            CategoriesVisualizer,
            SubPanelChips
        },

        props: {
            filter: {
                required: true,
                type: Object,
            },
        },

        data() {
            return {
                operations: [
                    {value: 'must_not', text: 'Exclude'},
                    {value: 'must', text: 'Include'}
                ],
            }
        },

        computed: {

            filtersText() {
                return this.getOperationText + ' ' + this.getStatusesText + ' in the past ' + this.getDurationText + ' days';
            },

            filtersExist() {
                return this.filter.active || this.filter.excludeCategoriesActive || this.filter.includeSubpanelsActive;
            },

            getOperationText() {
                let found = this.operations.find((operation) => {
                    return operation.value === this.filter.excludeOperation;
                });

                if (found) return found.text;
            },

            getDurationText() {
                return this.filter.excludeDays;
            },

            getStatusesText() {
                return this.statusesText([...this.filter.excludeStatuses]);
            },

            excludeCategoriesStatusesText() {
                return this.statusesText([...this.filter.excludeCategoriesStatuses]);
            },

            excludeCategoriesDaysText() {
                return this.filter.excludeCategoriesDays;
            },
        },

        methods: {

            statusesText(statusItems) {

                let statuses = [];

                statusItems.forEach(status => {
                    statuses.push(status);
                });

                let text = 'anybody who has status ';

                if (statusItems.length > 1) {
                    let lastStatus = statusItems.pop();
                    return text + statusItems.join(', ') + ' or ' + lastStatus;
                } else {
                    return text + statusItems.pop();
                }
            },
        }
    }
</script>
